<template>
  <div class="Signal-Form-Popup">
    <div class="Signal-Form-Popup__wrapper Anim__dropdown-wrapper">
      <div class="Signal-Form-Popup__hdr">
        <TypographyTitle :level="'h3'">Добавить сигнал</TypographyTitle>
        <ButtonClose @click="toCloseForm" />
      </div>
      <div class="Signal-Form-Popup__body">
        <form ref="form">
          <FormSignal 
            class="Signal-Form-Popup__form" 
            :initData="EDIT_SIGNAL_ID ? getEditData() : get_draftForm" 
            :errors="errors" 
            @formChange="toUpdateDraft"
          />
        </form>
        <ButtonMain 
          class="Signal-Form-Popup__submit" 
          :width="'100%'" 
          :height="'48px'" 
          @click="toSend" 
          :loading="get_isLoading"
        >
          {{ EDIT_SIGNAL_ID ? 'Редактировать' : 'Добавить сигнал' }}
        </ButtonMain>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed, ref, onBeforeUnmount } from 'vue';
  import { checkValidUrl } from '@shared/utils/links/checkValidUrl';
  import { checkNumeric } from '@shared/utils/checking/checkNumeric.js';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  //-----------------------------
  import TypographyTitle from '@ui/Typography/TypographyTitle/TypographyTitle.vue';
  import ButtonClose from '@ui/Buttons/ButtonClose/ButtonClose.vue';
  import ButtonMain from '@ui/Buttons/ButtonMain/ButtonMain.vue';
  import FormSignal from '@entities/Forms/FormSignal/FormSignal.vue';
  //-----------------------------
  const store = useStore();
  //-----------------------------
  const form = ref(null);
  const errors = ref({});
  //-----------------------------
  const EDIT_SIGNAL_ID = store.state.Signals.idEditSignal;
  //-----------------------------
  onBeforeUnmount(() => {
    store.dispatch('Signals/updateIdEditSignal', null);
  })
  //-----------------------------
  //Отобразить процесс отправки сигнала на сервер
  const get_isLoading = computed(() => store.state.Signals.isSignalSendLoading);
  //Получить черновик формы
  const get_draftForm = computed(() => store.state.Signals.draftForm);
  //-----------------------------
  //Отправить данные на сервер
  const toSend = async () => {
    const formData = new FormData(form.value);
    checkErrors(formData);
    if(Object.keys(errors.value).length > 0) return;
    try{
      if(EDIT_SIGNAL_ID){
        await store.dispatch('Signals/changeSignal', formData);
        store.dispatch('OverlayManagerSystem/addMessage', { text: 'Сигнал изменен', color: 'green' });
      }else{
        await store.dispatch('Signals/addSignal', formData);
        store.dispatch('OverlayManagerSystem/addMessage', { text: 'Сигнал добавлен', color: 'green' });
      }
    }catch{
      if(EDIT_SIGNAL_ID){
        store.dispatch('OverlayManagerSystem/addMessage', { text: 'Ошибка при редактировании сигнала', color: 'red' });
      }else{
        store.dispatch('OverlayManagerSystem/addMessage', { text: 'Ошибка при добавлении сигнала', color: 'red' });
      }
    }finally{
      toCloseForm();
    }
  };
  //Проверить поля формы
  const checkErrors = (form) => {
    errors.value = {};
    form.forEach((value, key) => {
      if(key === 'title' && value.trim() === '') errors.value[key] = 'Отсутствует заголовок';
      if(key === 'link'){
        if(value.trim() === '') errors.value[key] = 'Отсутствует источник';
        else if(!checkValidUrl(value)) errors.value[key] = 'Некорректная ссылка';
      }
      if(key === 'content' && value.trim() === '') errors.value[key] = 'Отсутствует описание сигнала';
      if(key === "price_usd" && form.has("coin") && !checkNumeric(value)) errors.value[key] = 'Значение не является числом';
    });
    if(!form.has("coin")) errors.value['coin'] = 'Отсутствует монета';
  };
  //Обновить черновик формы
  const toUpdateDraft = (data) => {
    if(EDIT_SIGNAL_ID) return;
    store.dispatch('Signals/saveDraftForm', data);
  };
  //Взять данные редактируемого поста
  const getEditData = () => {
    const data = store.state.Signals.data[EDIT_SIGNAL_ID];
    return {
      title: data.title,
      content: data.content,
      link: data.link,
      coin: data.coin.api_id,
      coin_object: data.coin,
      start_price_usd: data.start_price_usd,
      init_images: data.images_list,
    }
  }
  //Закрыть форму
  const toCloseForm = () => {
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.signalForm);
  }
</script>

<style lang="scss">
  @import "./styles/styles";
</style>